<template>
  <Modal title="添加上课时间" v-model="visible" width="600">
    <Form ref="timeForm" class="form" :label-width="100"
      :model="timeParam" :rules="timeRule">
      <Row>
        <Col :span="22" >
          <Form-item label="选择上课时间" prop="openedTime">
            <Row :gutter="12">
              <Col :span="8">
                <Form-item prop="day">
                  <Date-picker type="date" placeholder="选择日期"
                    format="yyyy-MM-dd" :value="timeParam.dayStr"
                    @on-change="onChangeDate" :onfocus="false"></Date-picker>
                </Form-item>
              </Col>
              <Col :span="6">
                <Form-item prop="startTime">
                  <Time-picker format="HH:mm" placeholder="开始时间" :clearable="false"
                    :steps="[1, 5]" :value="timeParam.startTimeStr"
                    @on-change="onChangeStratTime" :onfocus="false"></Time-picker>
                  </Form-item>
              </Col>
              <Col :span="1"></Col>
              <Col :span="6">
                <Form-item prop="endTime">
                  <Time-picker format="HH:mm" placeholder="结束时间" :clearable="false"
                    :steps="[1, 5]" :value="timeParam.endTimeStr"
                    @on-change="onChangeEndTime" :onfocus="false"></Time-picker>
                </Form-item>
              </Col>
              <Col :span="3">
                <Button type="info" @click="addOpenedTime">添加</Button>
              </Col>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Form ref="timeListForm" class="form" :label-width="100"
      :model="{}" :rules="timeListRule">
      <Row>
        <Col :span="24" >
          <Form-item label="已选择时间" prop="openedTimeList" >
            <Row >
              <div v-for="(item, index) in openedTimeList" :key="index">
                <Col offset="1" span="7">
                  <label ><b>{{ item.dayStr }} {{ item.startTimeStr }}-{{ item.endTimeStr }}</b></label>
                </Col>
                <Col span="2">
                  <Button type="error" size="small" @click="removeOpenedTime(index)">删除</Button>
                </Col>
              </div>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="add">添加</Button>
    </div>
  </Modal>
</template>
<script>
  import { validateSlots } from '../../tools/timeSlotValidator'

  export default {
    name: 'TchInsertOpenedTimeModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let self = this
      return {
        visible: this.value,
        timeParam: {
          day: '',
          startTime: '',
        },
        loadingAdd: false,
        openedTimeList: [],
        existingOpenedSlots: [],
        existingShortTermSlots: [],
        existingRandomSlots: [],
        timeRule: {
          day: [
            { type: 'integer', required: true, message: '请选择日期', trigger: 'blur' }
          ],
          startTime: [
            { type: 'integer', required: true, message: '请选择开始时间', trigger: 'blur' },
            { validator (rule, value, callback, source, options) {
              let endTime = self.timeParam.endTime
              let errors = []
              if (endTime !== '' && value >= endTime) {
                errors.push('开始时间应在结束时间之前 ')
              }
              callback(errors)
            } }
          ],
          endTime: [
            { type: 'integer', required: true, message: '请选择结束时间', trigger: 'blur' }
          ],
          openedTime: [
            { validator (rule, value, callback, source, options) {
              let day = self.timeParam.day
              let startTime = self.timeParam.startTime
              let errors = []
              let nowTime = new Date().getTime() / 1000
              if (day !== '' && startTime !== '' && nowTime >= (day + startTime)) {
                errors.push('开始时间应在当前时间之后')
                callback(errors)
                return
              }
              let openedTimeList = self.openedTimeList
              let endTime = self.timeParam.endTime
              if (day === '' || startTime === '' || endTime === '' ||
                startTime >= endTime) {
                return
              }
              openedTimeList.forEach(element => {
                let tmpDay = element.day
                let tmpStratTime = element.startTime
                let tmpEndTime = element.endTime
                if (day === tmpDay &&
                  ((tmpStratTime < startTime && tmpEndTime > startTime) ||
                  (tmpStratTime < endTime && tmpEndTime > endTime) ||
                  (tmpStratTime >= startTime && tmpEndTime <= endTime))) {
                  errors.push('添加的时间与 ' + element.dayStr + ' ' +
                    element.startTimeStr + '-' + element.endTimeStr + ' 冲突')
                }
              })
              callback(errors)
            } }
          ],
        },
        timeListRule: {
          openedTimeList: [
            { validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let errors = []
              if (openedTimeList.length <= 0) {
                errors.push('请添加上课时间')
              }
              callback(errors)
            } }
          ]
        },
      }
    },
    methods: {
      addOpenedTime () {
        let self = this
        self.$refs.timeForm.validate((valid) => {
          if (!valid) {
            return
          }
          let openedTime = {}
          openedTime.day = self.timeParam.day
          openedTime.dayStr = self.timeParam.dayStr
          openedTime.startTime = self.timeParam.startTime
          openedTime.startTimeStr = self.timeParam.startTimeStr
          openedTime.endTime = self.timeParam.endTime
          openedTime.endTimeStr = self.timeParam.endTimeStr
          self.openedTimeList.push(openedTime)
        })
      },
      removeOpenedTime (index) {
        this.openedTimeList.splice(index, 1)
      },
      onChangeDate (val) {
        this.timeParam.dayStr = val
        this.timeParam.day = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'))
      },
      onChangeStratTime (val) {
        this.timeParam.startTime = val && parseInt(this.$dateUtil.getSecondByHm(val))
        this.timeParam.startTimeStr = val
      },
      onChangeEndTime (val) {
        this.timeParam.endTime = val && parseInt(this.$dateUtil.getSecondByHm(val))
        this.timeParam.endTimeStr = val
      },
      add () {
        let self = this
        this.$refs.timeListForm.validate((valid) => {
          if (!valid) {
            return
          }
          // const result = validateSlots(
          //   self.openedTimeList,
          //   self.existingOpenedSlots,
          //   self.existingShortTermSlots,
          //   self.existingRandomSlots
          // )
          // if (!result.valid) {
          //   self.$Message.warning(result.errors[0])
          //   return
          // }
          self.loadingAdd = true
          self.openedTimeList.forEach(element => {
            element.tchId = self.tchId
          })
          self.$http.post('/tch/time/addBookRandomOpenedTime', {}, {
            transformRequest: [function (data, headers) {
              return JSON.stringify(self.openedTimeList)
            }],
            headers: {'Content-Type': 'application/json;charset=utf-8'},
          }).then(function (res) {
            self.loadingAdd = false
            let data = res.data
            if (!data.isConflict) {
              self.successCallback()
              self.visible = false
              self.$Message.success('提交成功!')
            } else {
              // data
              let content = ''
              if (data.conflictOpenedTime.length > 0) {
                content += '与买断时间冲突：</br>'
                data.conflictOpenedTime.forEach(element => {
                  content += ('<b>' + self.$constant.weekZh[element.week] + ' ' +
                    self.$moment.unix(element.startTime).utc().format('HH:mm') + ' - ' +
                    self.$moment.unix(element.endTime).utc().format('HH:mm')) + '</b></br>'
                })
              }
              if (data.conflictRandomOpenedTime.length > 0) {
                content += '与上课时间冲突：</br>'
                data.conflictRandomOpenedTime.forEach(element => {
                  content += ('<b>' +
                    self.$moment.unix(element.startTime).format('YYYY-M-D HH:mm') + ' - ' +
                    self.$moment.unix(element.endTime).format('YYYY-M-D HH:mm')) + '</b></br>'
                })
              }
              self.$Message.error({
                content: content,
                duration: 3
              })
            }
          }).catch(function (e) {
            self.loadingAdd = false
          })
        })
      },
      loadExistingTimes () {
        let self = this
        self.existingOpenedSlots = []
        self.existingShortTermSlots = []
        self.existingRandomSlots = []
        // 加载已有买断时间
        self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
          if (res && res.data) {
            res.data.forEach(function (e) {
              e.weekStr = self.$constant.weekZh[e.week]
              e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm')
              e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm')
              self.existingOpenedSlots.push(e)
            })
          }
        })
        // 加载已有短期固定时间
        self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=1').then(function (res) {
          if (res && res.data) {
            res.data.forEach(function (e) {
              e.weekStr = self.$constant.weekZh[e.week]
              e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm')
              e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm')
              self.existingShortTermSlots.push(e)
            })
          }
        })
        // 加载已有上课时间
        self.$http.get('/tch/randomOpenedTime?tchId=' + self.tchId).then(function (res) {
          if (res && res.data) {
            res.data.forEach(function (e) {
              e.dayStr = self.$moment.unix(e.day).format('YYYY-MM-DD')
              e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm')
              e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm')
              self.existingRandomSlots.push(e)
            })
          }
        })
      }
    },
    watch: {
      value (val) {
        if (val === true) {
          this.loadExistingTimes()
        }
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.timeParam.dayStr = ''
          this.timeParam.startTimeStr = ''
          this.timeParam.endTimeStr = ''
          this.openedTimeList = []
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TchAddRandomOpenedTimeModal.vue?44fc8b23